export const DealRoom = ({ qs, question, setQuestion, onAsk, busy }) => (
  <div className="mt-16 max-w-3xl" data-testid="deal-room">
    <span className="t-label">Deal room, questions and answers</span>
    <p className="t-cap text-muted-s mt-2 measure">
      Questions reach Solera privately. Once answered, the exchange is on record for all
      members, without the asker's name.
    </p>
    <div className="mt-6 space-y-0">
      {qs.map((q) => (
        <div key={q.question_id} className="hairline py-5" data-testid={`question-${q.question_id}`}>
          <p className="t-body text-bone">{q.question}</p>
          <p className="t-cap text-muted-s mt-1 fig">
            {q.mine ? "Your question, " : "A member, "}{q.created_at?.slice(0, 10)}
          </p>
          {q.answer ? (
            <div className="mt-3 pl-5" style={{ borderLeft: "1px solid var(--rule)" }} data-testid={`answer-${q.question_id}`}>
              <span className="t-label">Solera</span>
              <p className="t-small text-bone mt-1">{q.answer}</p>
            </div>
          ) : (
            <p className="t-cap text-tint mt-2">Awaiting answer. Visible only to you.</p>
          )}
        </div>
      ))}
      {qs.length === 0 && <p className="t-small text-muted-s hairline py-5">No questions on record.</p>}
    </div>
    <div className="mt-6 flex gap-3">
      <input className="input-solera" placeholder="Ask Solera a question about this deal"
        value={question} onChange={(e) => setQuestion(e.target.value)} data-testid="question-input" />
      <button className="btn-primary whitespace-nowrap" disabled={busy || !question.trim()}
        onClick={onAsk} data-testid="question-submit-button">Ask</button>
    </div>
  </div>
);
